import React, { useEffect, useState, useRef } from "react";
import ImageGallery from "../../Components/ImageGallery/ImageGallery";
import DynamicTable from "../DynamicTable";

const SectionFour = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, setMessageBoard, setErrorTabEnable,data ,showMaximumChat } = props

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);

    const isYesStepValid = data?.step_4_yes_next_steps ? (data?.step_4_yes_next_steps || '' ).toLowerCase() !== 'no': false
    const isNoStepValid =data?.step_4_no_next_steps ? (data?.step_4_no_next_steps || '').toLowerCase() !== 'no':false

    // useEffect(()=>{
    //     if (onClickNo && data?.step_4_no_text?.toLowerCase() === "nan") {
    //         props?.addMessages("Work Order", 10);
    //     }
    // }, [onClickNo, onClickYes])

    // useEffect(()=>{

    //     if(onClickYes && data?.step_4_yes_call_logs){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_4_yes_call_logs })
    //           );
    //     }
    //     if(isNoStepValid && data?.step_4_no_call_logs ){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_4_no_call_logs })
    //           );
    //     }
    // })

    return (
        <>
            <div className="error-message-head1" style={{fontSize : showMaximumChat && '16px'}}>{data?.step_4_title}</div>
            <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_4_desc}}>
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_4_yes_call_logs })
                          );
                        handleButtonClick(4, "yes" ,{section : 'four',value:isYesStepValid})
                        setOnClickYes(true);
                        setOnClickNo(false);
                          // Update selectedOptions based on `step_1_yes_text`
                        if (isYesStepValid) {
                            setSelectedOptions([true, true, true, true, true, false, false]);
                        } else{
                            setSelectedOptions([true, true, true, true, false, false, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[4] === "yes" ? "clicked" : ""
                        }`}
              
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_4_no_call_logs })
                          );
              
                        handleButtonClick(4, "no",{section : 'four',value:isNoStepValid});
                        setOnClickYes(false);
                        setOnClickNo(true);
                        if (isNoStepValid) {
                            setSelectedOptions([true, true, true, true, true, false, false]);
                        } else{
                            setSelectedOptions([true, true, true, true, false, false, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[4] === "no" ? "clicked" : ""
                        }`}
               
                >
                    No
                </button>
            </div>
            {onClickYes && <div className="error-message-head2"  style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_4_yes_text}}></div>}
            {onClickNo && data?.step_4_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_4_no_text}}></div>}
           
            {onClickYes && data?.step_4_yes_call_logs && <DynamicTable data={data?.step_4_yes_call_logs} /> }
            {onClickNo && data?.step_4_no_call_logs && <DynamicTable data={data?.step_4_no_call_logs} /> }
            {/* <div className="error-message-head2">
                Request subscriber to perform reconnection procedure (switch off power
                supply, wait for 10 seconds and then switch on the power supply)
            </div> */}
            {/* <ImageGallery /> */}
            {/* <div className="error-message-head1">Call Logs</div> */}
        </>
    )
}

export default SectionFour
